function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import c from 'classnames';
import AnimateHeight from 'react-animate-height';
import useControlledState from 'ucs';
import WysiwygField from '../../WysiwygField';
import Icon from '../../Icon';
var ContentParsed = function ContentParsed(_ref) {
  var children = _ref.children;
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(WysiwygField, {
      html: children
    });
  }
  return /*#__PURE__*/React.createElement("div", null, children);
};
var AccordeonTitle = function AccordeonTitle(_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("h3", {
    className: className
  }, children);
};
var AccordionItem = function AccordionItem(props) {
  var title = props.title,
    content = props.content,
    iconClassName = props.iconClassName,
    materialIconName = props.materialIconName,
    duration = props.duration,
    easing = props.easing,
    titleComponent = props.titleComponent,
    className = props.className,
    value = props.value,
    onChange = props.onChange,
    defaultValue = props.defaultValue;
  var _useControlledState = useControlledState(value, onChange, defaultValue),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    collapsed = _useControlledState2[0],
    setCollapsed = _useControlledState2[1];
  var classes = c(className, 'Accordion__item', {
    collapsed: collapsed
  });
  var iconClasses = c('icon', iconClassName);
  var AccordeonTitle = titleComponent;
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(AccordeonTitle, {
    className: "Accordion__item__title"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setCollapsed(!collapsed);
    },
    "aria-expanded": !collapsed
  }, materialIconName ? /*#__PURE__*/React.createElement(Icon, {
    name: materialIconName,
    flair: "outlined",
    className: iconClassName
  }) : /*#__PURE__*/React.createElement("span", {
    className: iconClasses
  }), title)), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: duration,
    easing: easing,
    height: collapsed ? 0 : 'auto'
  }, /*#__PURE__*/React.createElement("div", {
    className: "Accordion__item__content",
    "aria-hidden": collapsed
  }, /*#__PURE__*/React.createElement(ContentParsed, null, content))));
};
AccordionItem.defaultProps = {
  title: 'Default title',
  content: 'Default content',
  iconClassName: 'icon--arrow-right icon--variant-1',
  duration: 333,
  easing: 'cubic-bezier(0, 0, .2, 1)',
  titleComponent: AccordeonTitle,
  defaultValue: true
};
export default AccordionItem;